export default {
  SELECTED_PROJECT(state, value) {
    state.selectedProjectDetails = value;
  },

  SET_ADDON_TYPE(state, value) {
    state.addOnType = value;
  },
};
